import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { IAuthResponse, User, sxfw } from '../../Interfaces';
import { getUsers } from '../../Data/ApiUserRequests';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../../Components/LoginForm';
import { RoleTransate } from '../../Helpers/Translations';
import AddUserForm from '../../Components/AddUserForm/AddUserForm';
import { DataGrid, GridCellParams, GridColDef, GridRowClassNameParams, GridTreeNode, MuiEvent } from '@mui/x-data-grid';

type userField = {
  id: string,
  fullName: string,
  userName: string,
  standorte: string,
  roleString: string,
}

const UserManager: React.FC = () => {
  const bearerToken: IAuthResponse = useSelector((state: IAuthResponse) => state)
  const navigate = useNavigate();
  const [tblUsers, setTblUsers] = useState<userField[]>([])
  const [isNewUser, setIsNewUser] = useState(false);
  const [isAddUpdateOpenDialog, setIsAddUpdateOpenDialog] = useState(false)
  const [errorAddText, setErrorAddText] = useState('');
  const [operationAddResult, setOperationAddResult] = useState('')
  const [newUserAdded, setNewUserAdded] = useState(0)

  const handleChildClick = (value: number) => {
    console.log('Value received in parent:', value);
    setNewUserAdded(value)
  };

  const loadUsers = async() => {
    getUsers(bearerToken.token)
    .then(response => {
        const us:User[] = response
        const locTusers: userField[] = []
        us.map( u=> {
          const standorte = `<div style='width: 300px'>${
  u.assignedHotels?.map(x => `<span><a href='/locations/${x.wnummer}'>${x.name}</a></span>`).join(', ')
}</div>`;
          return (
            locTusers.push( {
              id: u.id??'',
              fullName: u.fullName,
              roleString: RoleTransate(u.roleString??''),
              standorte:  standorte,
            userName: u.userName
            })
          )
        })
        setTblUsers(locTusers)

    }).catch(error => {
        console.log('Error on load the data', error)
    })
  }

  const columns: GridColDef[] = [
    { field: 'fullName', headerName: 'Name', minWidth: 110, maxWidth: 200, flex: 0  },
    { field: 'userName', headerName: 'Konto', minWidth: 110,  maxWidth: 200, flex: 1  },
    { field: 'roleString', headerName: 'Rolle', minWidth: 110,   maxWidth: 110, flex: 0  },
    { field: 'standorte', headerName: 'Standort(e)', minWidth: 120, flex: 1 ,
    renderCell: (params) => (
      <div
        dangerouslySetInnerHTML={{
          __html: params.value
        }}
      />
    ),
    sortable: false,
     }
];

  useEffect( () => {
    loadUsers()
  }, [newUserAdded])

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  const getMyRowClassName = (params: GridRowClassNameParams<any>) => {
    return (params.indexRelativeToCurrentPage % 2 === 0) ? 'stripeOdd' : 'stripeEven'
  };


  function openUserCardCell(params: GridCellParams<any, unknown, unknown, GridTreeNode>, event: MuiEvent<React.MouseEvent<HTMLElement, MouseEvent>>): void {
    if (params.field !== 'standorte' ) {
       navigate("/usermanager/" + params.row.id)
     } else {
       event.defaultMuiPrevented = true;
     }
  }

  return (
    <div>
      {
        bearerToken.role === 'Admin' &&
        <>
        <h2>Nutzerverwaltung</h2>
        <div>
            <Dialog open={isNewUser}>
              <DialogContent>
              < AddUserForm setIsNewUserAdded={handleChildClick} />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => {
                  setIsNewUser(false);
                  setOperationAddResult('')
                  setErrorAddText('')
                  navigate('/usermanager/')

                }}>Schliessen</Button>
              </DialogActions>
            </Dialog>


            <Dialog open={isAddUpdateOpenDialog}>
            <DialogTitle></DialogTitle>
            <DialogContent>
            <Alert severity={errorAddText !== '' ? 'error' : 'success' } >
                {errorAddText !== '' ?  errorAddText : operationAddResult  }
            </Alert>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {
                  setIsNewUser(false);
                  setIsAddUpdateOpenDialog(false);
                  setOperationAddResult('');
                  setErrorAddText('');
                  }}>Schliessen</Button>
            </DialogActions>
        </Dialog>
        </div>

        <Box  sx={sxfw}>
        <Button variant='outlined' color='success' onClick={ () => {
          setIsNewUser(true)
        }}>neuen Nutzer hinzufügen</Button></Box>


<DataGrid rows={tblUsers}
sx={{width: 'auto'}}
  columns={columns}
  hideFooter={false}
  pagination={true}
  pageSizeOptions={[25, 50, 100]}
  initialState={{
    pagination: {paginationModel: {pageSize: 50}}
  }}
  getRowId={(row: any) => row.id}
  getRowClassName={ getMyRowClassName}
  onCellClick={openUserCardCell}
 />
        </>
      }

{
    (!bearerToken.isLoggedIn) && <Box sx={{p: 1, m: 1}}><LoginForm /></Box>
}
    </div>
  );
};

export default UserManager;
